var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10400",
    "data-name": "Group 10400",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.25,
    height: 20,
    viewBox: "0 0 20.25 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3043",
    "data-name": "Rectangle 3043",
    width: 11.145,
    height: 11.89,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10159",
    "data-name": "Group 10159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10055",
    "data-name": "Group 10055"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2970",
    "data-name": "Rectangle 2970",
    width: 20.25,
    height: 20,
    rx: 10,
    fill: "#4a90f7"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10168",
    "data-name": "Group 10168",
    transform: "translate(4.538 3.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10167",
    "data-name": "Group 10167",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3247",
    "data-name": "Path 3247",
    d: "M.6,28.715a.766.766,0,0,1-.451-.3.915.915,0,0,1-.145-.405C0,27.018,0,26.028,0,25.037a.189.189,0,0,1,.007-.03H1.481V27.22H9.653V25h1.492v3.112a2.867,2.867,0,0,1-.145.3.816.816,0,0,1-.459.307Z",
    transform: "translate(0 -16.825)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3248",
    "data-name": "Path 3248",
    d: "M32.239,35.12a.817.817,0,0,0,.459-.307,2.933,2.933,0,0,0,.145-.3v.6Z",
    transform: "translate(-21.697 -23.23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3249",
    "data-name": "Path 3249",
    d: "M9.808,5.2V.443c0-.31.134-.442.446-.442h1.382a.368.368,0,0,1,.4.405q0,2.322,0,4.644V5.2h.131c.426,0,.851,0,1.277,0a.386.386,0,0,1,.307.68Q12.66,7.124,11.572,8.37c-.107.122-.213.246-.321.367a.384.384,0,0,1-.656,0Q9.58,7.583,8.569,6.424c-.166-.189-.331-.379-.5-.568a.378.378,0,0,1-.087-.437A.385.385,0,0,1,8.374,5.2c.472,0,.944,0,1.433,0",
    transform: "translate(-5.349 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpDownload);
export default __webpack_public_path__ + "static/media/op-download.57b30304e95154199ac22e5333dd9812.svg";
export { ForwardRef as ReactComponent };